// Texts of the perimeter screens live under this key of the locales.
export const PERIMETER_TEXT_ROOT = 'companyContacts.perimeters';

export const perimeterText = (language, key) =>
  language.getValue(`${PERIMETER_TEXT_ROOT}.${key}`, '');

// Split/join instead of String.replace: a replacement string interprets "$&"
// and similar patterns, which a user-typed perimeter name can contain.
export const fillText = (template, values) =>
  Object.entries(values).reduce(
    (text, [key, value]) => text.split(`{${key}}`).join(String(value)),
    template || '',
  );

// French plural rule: 0 and 1 take the singular form.
export const getCountText = (language, key, count, values = {}) =>
  fillText(perimeterText(language, `${key}.${count > 1 ? 'many' : 'one'}`), {
    count,
    ...values,
  });

// DD/MM/YYYY, or "" when the value is not a usable date.
export const formatShortDate = (value) => {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};
